import type { StyleRule } from '@archipro-design/aria';
import {
    buttonClassName,
    productInfoSlotClassNames,
    productTileSlotClassNames,
    captionClassName,
    pxArrayToRem,
    pxToRem,
} from '@archipro-design/aria';
import { PADDING_LEFT_RIGHT_SECTION_MOBILE } from '../../common/pagebuilder.style';
import type { ColumnDimensionType } from '@modules/page-builder/types';

const PRODUCT_INFO_MIN_HEIGHT = 110;

export const DetailSingleImageContainer: StyleRule<{
    isTagging?: boolean;
    dimension?: ColumnDimensionType;
    isLinked?: boolean;
}> = ({ isTagging, theme, dimension, isLinked }) => ({
    position: 'relative',
    width: dimension?.mobileWidth ? pxToRem(dimension.mobileWidth) : '100%',
    height: dimension?.mobileHeight ? pxToRem(dimension.mobileHeight) : '100%',

    [theme.screen.laptop]: {
        width: dimension?.width ? pxToRem(dimension.width) : '100%',
        height: dimension?.height ? pxToRem(dimension.height) : '100%',
    },

    '&:hover': {
        '& .hover-buttons-image': {
            opacity: isTagging ? 0 : 1,
            visibility: isTagging ? 'hidden' : 'visible',
        },
    },
    cursor: !isTagging && isLinked ? 'pointer' : 'default',
    margin: 'auto',
});

export const SingleImageWithProductContainer: StyleRule<{
    dimension?: ColumnDimensionType;
    variant?: '01' | '02';
}> = ({ theme, dimension, variant }) => ({
    position: 'relative',
    width: dimension?.mobileWidth ? pxToRem(dimension.mobileWidth) : '50%',
    height: 'auto',
    minHeight: dimension?.mobileHeight
        ? pxToRem(dimension.mobileHeight + PRODUCT_INFO_MIN_HEIGHT)
        : 0,

    [`& .${productInfoSlotClassNames.container}`]: {
        padding:
            variant === '02' ? pxArrayToRem([0, 18]) : pxArrayToRem([0, 12]),
    },

    [`& .${productTileSlotClassNames.variants} .${captionClassName}`]: {
        fontSize: pxToRem(12),
    },

    [theme.screen.laptop]: {
        width: dimension?.width ? pxToRem(dimension.width) : '100%',
        minHeight: dimension?.height
            ? pxToRem(dimension.height + PRODUCT_INFO_MIN_HEIGHT)
            : 0,
        [`& .${productInfoSlotClassNames.container}`]: {
            padding: 0,
        },

        [`& .${productTileSlotClassNames.variants} .${captionClassName}`]: {
            fontSize: pxToRem(16),
        },
    },
});

export const ImageCaptionContainer: StyleRule<{
    dimension?: ColumnDimensionType;
}> = ({ theme, dimension }) => ({
    flexGrow: 1,
    position: 'relative',
    width: '100%',
    maxWidth: dimension?.mobileWidth ? pxToRem(dimension.mobileWidth) : 'unset',
    height: 'auto',
    margin: 'auto',

    [theme.screen.laptop]: {
        maxWidth: dimension?.width ? pxToRem(dimension.width) : '100%',
    },
});

export const MobileCaptionContainer: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([0, PADDING_LEFT_RIGHT_SECTION_MOBILE]),
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
    flexDirection: 'column',
    [theme.screen.tablet]: {
        padding: 0,
    },
});

export const DetailSingleImageLinkedIcon: StyleRule = () => ({
    zIndex: 1,
    position: 'absolute',
    bottom: pxToRem(12),
    right: pxToRem(12),

    [`& .${buttonClassName}`]: {
        borderRadius: '50%',
        padding: pxToRem(8),
        width: pxToRem(48),
        height: pxToRem(48),
    },
});
